/*
 ** Manter esse arquivo organizado por ordem alfabética
 */
export enum FeatureFlags {
  CS_CHAT = 'CS_CHAT',
  TRADE_3_0 = 'TRADE_3_0',
  DISABLE_WARREN_BUILDER = 'DISABLE_WARREN_BUILDER',
  PLATFORM_MAINTENANCE = 'br.com.warren.foundation.platform-maintenance',
  IS_PARTNER_WEB_DISABLED = 'br.com.warren.disable-partner-web',
  REGULATORY_UPDATE_BUREAU = 'br.com.warren.experience.regulatory-update-bureau',
  ENABLE_FATCA_IN_REGULATORY_UPDATE = 'br.com.warren.experience.enable-fatca-in-regulatory-update',
  ENABLE_NEW_ACCOUNT_STATES = 'br.com.warren.experience.enable-new-account-states',
  ENABLE_NEW_CEP = 'br.com.warren.experience.enable-new-cep',
  ENABLE_NEW_HOMEBROKER = 'br.com.warren.enable-new-homebroker',
  ENABLE_ON_GOING_REDEMPTIONS = 'br.com.warren.on-going-redemptions',
  ENABLE_BFF_PORTFOLIO_MIGRATION = 'br.com.warren.experience.enable-new-portfolios-bff',
  ENABLE_SECONDARY_MARKET = 'br.com.warren.enable-rf-secundary-market',
  PORTABILITY_EXIT_MENU_ITEM = 'br.com.warren.enable-digital-portability',
  ENABLE_BFF_INVESTMENTS_MIGRATION = 'br.com.warren.experience.enable-bff-investments-migration',
  ENABLE_ADVISOR_CHANGE = 'br.com.warren.experience.enable-advisor-change'
}
